import React from 'react';
import './BroadbandRouter.css';

interface BroadbandPlanProps {
  selected: boolean;
  onSelect: () => void;
}

const BroadbandRouterBYO: React.FC<BroadbandPlanProps> = ({ selected, onSelect }) => {

  return (
      <div
          className={`w-full lg:min-h-[35rem] bg-white border border-gray-200 rounded-lg col-span-full group md:col-span-1 group hover:bg-fred-blue-600 hover:cursor-pointer ${selected ? 'active' : ''}`}
          onClick={() => onSelect()}>
        <div className="w-full px-4 py-2 sm:px-8 sm:py-4">
          <div className='flex justify-between items-center min-h-20'>
            <h5 className={`text-3xl font-semibold text-fred-purple-500 group-hover:text-white ${selected ? 'active' : ''}`}>No,
              BYO
              Router</h5>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                 stroke-width="1.5"
                 stroke="currentColor"
                 className={`hidden w-12 h-12 group-hover:block group-hover:text-white ${selected ? 'active' : ''}`}>
              <path stroke-linecap="round" stroke-linejoin="round"
                    d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z"/>
            </svg>
          </div>
          <div className="flex flex-col justify-center items-center gap-4">
            <img className="w-1/2" src="images/wifi-router-byo.png" alt="Broadband router"/>
          </div>
          <div className={`description flex items-baseline my-4 ${selected ? 'active' : ''}`}>
            <p className="text-sm font-normal text-gray-500 group-hover:text-gray-100">Use our broadband connection with your own modem/router. To use your existing modem for FREDNET please check our settings on the FAQ page.</p>
          </div>
        </div>
      </div>
  );
};

export default BroadbandRouterBYO;
